import React, { HTMLAttributes, JSXElementConstructor } from 'react';

type colSpanOrder = {
	span?: number;
	order?: number;
	offset?: number;
};

export interface IColProps extends HTMLAttributes<any> {
	as?: string | JSXElementConstructor<any>;
	xs?: number | boolean | colSpanOrder;
	sm?: number | boolean | colSpanOrder;
	md?: number | boolean | colSpanOrder;
	lg?: number | boolean | colSpanOrder;
}

const Col = ({
    className = '',
    as = 'div',
    children,
    xs,
    sm,
    md,
    lg,
    ...rest
}: IColProps) => {
    const As: string | JSXElementConstructor<any> = as;
    const getClassNames = (breakpoint: string, value?: IColProps['xs']) => {
        let classNames = '';
        if (value && typeof value === 'object') {
            if (value.order) {
                classNames += ` ORDER-${
                    breakpoint === 'xs' ? '' : `${breakpoint.toUpperCase()}-`
                }${value.order.toString().toUpperCase()}`;
            }
            if (value.offset) {
                classNames += ` OFFSET-${
                    breakpoint === 'xs' ? '' : `${breakpoint.toUpperCase()}-`
                }${value.offset}`;
            }
            if (value.span) {
                classNames += ` COL-${
                    breakpoint === 'xs' ? '' : `${breakpoint.toUpperCase()}-`
                }${value.span}`;
            }
        } else if (value && value === true) {
            classNames +=
				breakpoint === 'xs' ? '' : ` COL-${breakpoint.toUpperCase()}`;
        } else if (value && value.toString().length > 0) {
            classNames += ` COL-${
                breakpoint === 'xs' ? '' : `${breakpoint.toUpperCase()}-`
            }${value.toString().toUpperCase()}`;
        }
        return classNames;
    };
    return (
        <As
            className={`Col ${className} ${getClassNames(
                'xs',
                xs,
            )} ${getClassNames('sm', sm)} ${getClassNames(
                'md',
                md,
            )} ${getClassNames('lg', lg)}`}
            {...rest}
        >
            {children}
        </As>
    );
};

export default Col;
